module.exports = __webpack_public_path__ + "img/fenghuang.6a3e8403.png";